import Splide from './splide.js';

let introHeight, curSlider;
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (event.target.closest('.c-text__slider')) {
      curSlider = event.target.closest('.c-text__slider').id;
    };
  }, false);
  if (document.querySelector(".c-intro__header--slider")) {
    const splide = new Splide('.splide', {
      arrows: false,
      autoplay: true,
      interval: 4000,
      speed: 800,
      lazyLoad: 'nearby'
    });
    splide.mount();
    splide.on('resize', function () {
      introHeight = document.querySelector(".c-intro__header").offsetHeight + 'px';
      document.documentElement.style.setProperty('--introHeight', introHeight);
    });
  } else if(document.querySelector(".c-intro__img")) {
    introHeight = document.querySelector(".c-intro__header").offsetHeight + 'px';
    document.documentElement.style.setProperty('--introHeight', introHeight);
    window.onresize = function() {
      introHeight = document.querySelector(".c-intro__header").offsetHeight + 'px';
      document.documentElement.style.setProperty('--introHeight', introHeight);
    }
  }
  if (document.querySelector(".c-text__slider")) {
    const splide = [];
    var elms = document.getElementsByClassName('splide');
    for (var i = 0; i < elms.length; i++) {
      splide[i] = new Splide(elms[i], {
        arrows: true,
        pagination: false,
        autoHeight: true,
        type: 'fade'
      });
      splide[i].mount();

      let mountParent = document.getElementById(splide[i].root.id);
      mountParent.querySelector('.slider-count').innerText = '1/' + mountParent.querySelectorAll('.slider-item').length;
      splide[i].on('moved', function (newIndex, prevIndex, destIndex) {
        if(curSlider === undefined) {
          curSlider = 'splide01';
        }
        let parent = document.getElementById(curSlider);
        parent.querySelector('.slider-count').innerText = (newIndex + 1) + '/' + parent.querySelectorAll('.slider-item').length;
      });
    }
  }
  document.querySelectorAll(".c-btn--consent").forEach(function(consent){
    consent.addEventListener('click', function(){
      function setCookie(cName, cValue, expDays) {
        var date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    }
    
    setCookie('cookie_notice_accepted', 'yes', 30);
    location.reload();
    return false;
  })
});

  document.querySelector(".c-btn-nav").addEventListener('click', function () {
    this.classList.toggle("is-active");
    document.querySelector(".c-nav").classList.toggle("is-active");
  });
});